import {
  plannerWhyDisplayParts,
} from '../../utils/mealPlanHelpers.js'

/**
 * Planner suggestion / row “why” line: render only the explanatory tail text.
 * The historical COOK NOW label is intentionally hidden for readability.
 *
 * @param {'desktop'|'mobile'} variant — mobile prefix separators inline after time/count
 */
export default function PlannerWhySuffix({ meal, variant = 'desktop' }) {
  const { tail } = plannerWhyDisplayParts(meal)
  if (!tail) return null

  if (variant === 'mobile') {
    return (
      <>
        {' · '}
        <span className="mobile-meal-why">{tail}</span>
      </>
    )
  }

  if (variant === 'block') {
    return <div className="planner-why-block">{tail}</div>
  }

  return (
    <span className="meal-row-why">· {tail}</span>
  )
}
